import { motion } from 'framer-motion';

const VARIANTS = {
  primary: 'btn btn-primary',
  secondary: 'btn btn-secondary',
  ghost: 'btn btn-ghost',
  danger: 'btn btn-danger',
};

const SIZES = {
  sm: 'btn-sm',
  md: '',
  lg: 'btn-lg',
  xl: 'btn-xl',
  icon: 'btn-icon',
};

/**
 * Reusable Button component with variants, sizes, and Framer Motion support.
 *
 * @param {'primary'|'secondary'|'ghost'|'danger'} variant
 * @param {'sm'|'md'|'lg'|'xl'|'icon'} size
 * @param {React.ReactNode} icon - Optional leading icon
 * @param {boolean} loading
 * @param {string} className - Additional CSS classes
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  icon,
  loading = false,
  disabled = false,
  className = '',
  children,
  onClick,
  type = 'button',
  ariaLabel,
  ...rest
}) {
  const classes = [
    VARIANTS[variant] || VARIANTS.primary,
    SIZES[size] || '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <motion.button
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      aria-label={ariaLabel}
      whileHover={!disabled ? { scale: 1.02 } : undefined}
      whileTap={!disabled ? { scale: 0.97 } : undefined}
      transition={{ duration: 0.15 }}
      {...rest}
    >
      {loading ? (
        <span className="animate-pulse">...</span>
      ) : (
        <>
          {icon && <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>}
          {children}
        </>
      )}
    </motion.button>
  );
}
